import gql from 'graphql-tag';

import type {
  AiRecomposeMode,
  AllInstructionsData,
  MediaGenerationParametersInput,
  TovInput,
} from 'src/data/generation';
import type { ImproveSectionInput, InstructionInput } from 'src/data/longForm';
import { executeGqlMutation, type GqlCallVariables } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation CreateLongFormImprovedDraft(
    $projectId: ID!
    $creationJobId: ID
    $sections: [ImproveSectionInput!]
    $recomposeMode: RecomposeModeEnum!
    $instruction: Instruction
    $tovInput: TovInput
    $mediaGenerationParameters: MediaGenerationParametersInput
    $onlyImproveScore: Boolean
    $structureInstructionsData: JSON
  ) {
    createLongFormImprovedDraft(
      projectId: $projectId
      creationJobId: $creationJobId
      sections: $sections
      recomposeMode: $recomposeMode
      instruction: $instruction
      tovInput: $tovInput
      mediaGenerationParameters: $mediaGenerationParameters
      onlyImproveScore: $onlyImproveScore
      structureInstructionsData: $structureInstructionsData
    ) {
      id
    }
  }
`;

interface Variables extends GqlCallVariables {
  projectId: ID;
  creationJobId?: ID;
  sections: ImproveSectionInput[];
  recomposeMode: AiRecomposeMode;
  instruction?: InstructionInput;
  tovInput?: TovInput;
  mediaGenerationParameters?: MediaGenerationParametersInput;
  onlyImproveScore?: boolean;
  structureInstructionsData?: AllInstructionsData;
}

interface Result {
  id: ID;
}

export const createLongFormImprovedDraft = async (variables: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(response.data);
};
